import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivCustomerContractRateViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
export class CustomerContractRateBase implements MrfiktivCustomerContractRateViewModelGen {
  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.customer.minimumTermInMonths" })
  minimumTermInMonths?: number | null;
  get minimumTermInMonthsFormable(): number | null | undefined {
    return this.minimumTermInMonths ?? null;
  }
  set minimumTermInMonthsFormable(v: number | null | undefined) {
    this.minimumTermInMonths = v == null || `${v}` === "" ? null : Number(v);
  }

  @FilterConfig({ type: FilterTypes.STRING, displayName: "objects.contract.customer.cancellationNoticePeriod" })
  cancellationNoticePeriod?: string | null;

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.customer.breakdownFeePerCase" })
  breakdownFeePerCase?: number | null;
  get breakdownFeePerCaseFormable(): number | null | undefined {
    return this.breakdownFeePerCase ?? null;
  }
  set breakdownFeePerCaseFormable(v: number | null | undefined) {
    this.breakdownFeePerCase = v == null || `${v}` === "" ? null : Number(v);
  }

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.customer.accidentFeePerCase" })
  accidentFeePerCase?: number | null;
  get accidentFeePerCaseFormable(): number | null | undefined {
    return this.accidentFeePerCase ?? null;
  }
  set accidentFeePerCaseFormable(v: number | null | undefined) {
    this.accidentFeePerCase = v == null || `${v}` === "" ? null : Number(v);
  }

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.customer.managementFeePerVehicleMonthly" })
  managementFeePerVehicleMonthly?: number | null;
  get managementFeePerVehicleMonthlyFormable(): number | null | undefined {
    return this.managementFeePerVehicleMonthly ?? null;
  }
  set managementFeePerVehicleMonthlyFormable(v: number | null | undefined) {
    this.managementFeePerVehicleMonthly = v == null || `${v}` === "" ? null : Number(v);
  }

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.customer.comprehensiveRepairApprovalLimit" })
  comprehensiveRepairApprovalLimit?: number | null;
  get comprehensiveRepairApprovalLimitFormable(): number | null | undefined {
    return this.comprehensiveRepairApprovalLimit ?? null;
  }
  set comprehensiveRepairApprovalLimitFormable(v: number | null | undefined) {
    this.comprehensiveRepairApprovalLimit = v == null || `${v}` === "" ? null : Number(v);
  }

  @FilterConfig({ type: FilterTypes.NUMBER, displayName: "objects.contract.customer.liabilityRepairApprovalLimit" })
  liabilityRepairApprovalLimit?: number | null;
  get liabilityRepairApprovalLimitFormable(): number | null | undefined {
    return this.liabilityRepairApprovalLimit ?? null;
  }
  set liabilityRepairApprovalLimitFormable(v: number | null | undefined) {
    this.liabilityRepairApprovalLimit = v == null || `${v}` === "" ? null : Number(v);
  }

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.contract.customer.purchaseVehicleRepairApprovalLimit"
  })
  purchaseVehicleRepairApprovalLimit?: number | null;
  get purchaseVehicleRepairApprovalLimitFormable(): number | null | undefined {
    return this.purchaseVehicleRepairApprovalLimit ?? null;
  }
  set purchaseVehicleRepairApprovalLimitFormable(v: number | null | undefined) {
    this.purchaseVehicleRepairApprovalLimit = v == null || `${v}` === "" ? null : Number(v);
  }

  @FilterConfig({ type: FilterTypes.STRING, displayName: "objects.contract.customer.comprehensiveRentalCarDefault" })
  comprehensiveRentalCarDefault?: string | null;

  @FilterConfig({ type: FilterTypes.STRING, displayName: "objects.contract.customer.rentalCarVIPDefault" })
  rentalCarVIPDefault?: string | null;

  @FilterConfig({ type: FilterTypes.STRING, displayName: "objects.contract.customer.rentalCarThirdPartyDamageDefault" })
  rentalCarThirdPartyDamageDefault?: string | null;

  @FilterConfig({ type: FilterTypes.BOOLEAN, displayName: "objects.contract.customer.isWrappingIncluded" })
  isWrappingIncluded?: boolean | null;

  constructor(data?: Partial<MrfiktivCustomerContractRateViewModelGen>) {
    this.minimumTermInMonths = data?.minimumTermInMonths;
    this.cancellationNoticePeriod = data?.cancellationNoticePeriod;
    this.breakdownFeePerCase = data?.breakdownFeePerCase;
    this.accidentFeePerCase = data?.accidentFeePerCase;
    this.managementFeePerVehicleMonthly = data?.managementFeePerVehicleMonthly;
    this.comprehensiveRepairApprovalLimit = data?.comprehensiveRepairApprovalLimit;
    this.liabilityRepairApprovalLimit = data?.liabilityRepairApprovalLimit;
    this.purchaseVehicleRepairApprovalLimit = data?.purchaseVehicleRepairApprovalLimit;
    this.comprehensiveRentalCarDefault = data?.comprehensiveRentalCarDefault;
    this.rentalCarVIPDefault = data?.rentalCarVIPDefault;
    this.rentalCarThirdPartyDamageDefault = data?.rentalCarThirdPartyDamageDefault;
    this.isWrappingIncluded = data?.isWrappingIncluded;
  }

  map(data: MrfiktivCustomerContractRateViewModelGen): void {
    this.minimumTermInMonths = data?.minimumTermInMonths;
    this.cancellationNoticePeriod = data?.cancellationNoticePeriod;
    this.breakdownFeePerCase = data?.breakdownFeePerCase;
    this.accidentFeePerCase = data?.accidentFeePerCase;
    this.managementFeePerVehicleMonthly = data?.managementFeePerVehicleMonthly;
    this.comprehensiveRepairApprovalLimit = data?.comprehensiveRepairApprovalLimit;
    this.liabilityRepairApprovalLimit = data?.liabilityRepairApprovalLimit;
    this.purchaseVehicleRepairApprovalLimit = data?.purchaseVehicleRepairApprovalLimit;
    this.comprehensiveRentalCarDefault = data?.comprehensiveRentalCarDefault;
    this.rentalCarVIPDefault = data?.rentalCarVIPDefault;
    this.rentalCarThirdPartyDamageDefault = data?.rentalCarThirdPartyDamageDefault;
    this.isWrappingIncluded = data?.isWrappingIncluded;
  }
}

type ICustomerContractRate = CustomerContractRateBase;
const CustomerContractRate = Filter.createForClass(CustomerContractRateBase);

export { CustomerContractRate, ICustomerContractRate };
